import { Link } from 'react-router-dom';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/gossip';

export default function FaqSection() {
  return (
    <section className="mx-auto max-w-[1240px] px-4 py-16 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-primary-600">
            <span className="h-3 w-1 rounded-full bg-primary-500" aria-hidden="true" />
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            你可能想先弄清楚这几件事
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            关于内容来源、更新节奏与订阅方式，我们整理了几个问得最多的问题。如果还有疑问，欢迎直接联系我们。
          </p>
          <Link
            to="/faq"
            className="mt-6 flex h-10 w-fit cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            查看完整问答
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="lg:col-span-8">
          <FaqAccordion items={faqs.slice(0, 4)} />
        </div>
      </div>
    </section>
  );
}